import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography'

import CaseInfoEdit from './CaseInfoEdit';
import CaseInfoView from './CaseInfoView';

const CaseInfoCard = ({ caseInfo, onChange }) => {
    const [editView, setEditView] = useState(false);
   
    const { caseReference = '' } = caseInfo;
    
    const reloadPage = () => {
        setEditView(false);
        window.location.reload();
    }

    return (
        <Paper style={{ padding: '1rem', marginTop: '1rem' }}>
            <Grid container spacing={1}>
                <Grid item >
                    <Typography 
                        onClick={() => {
                            console.log('caseInfo', caseInfo);
                        }}
                        variant="button" colour="textSecondary">CASE NUMBER {caseReference}</Typography>
                </Grid>
                <Grid item style={{ marginRight: '1rem'}} >
                    <EditIcon color="action" onClick={() => setEditView(true)} />
                </Grid>
            </Grid>
            {
                editView ? <CaseInfoEdit caseInfo={caseInfo} onChange={onChange} onComplete={reloadPage} /> : <CaseInfoView caseInfo={caseInfo} />

            }
        </Paper >
    );
};

export default CaseInfoCard;